import React, { useContext , useEffect, useRef, useState } from "react";
import styles from './Catalogue.module.css';
import buttonStyles from '../../buttons/Buttons.module.css';
import generalStyles from '../generalAssets/GeneralAssets.module.css';
import { BrandCountryContext } from "../../providers/BrandCountryProvider";
import { Link, NavLink, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import TabNavigation from "../../tabNavigation/TabNavigation";
import { LoggedInContext } from "../../providers/LoggedInContext";
import HiQTabNavigation from "../../tabNavigation/HiQTabNavigation";
import ProductCard from "./ProductCard";
import { sortAlphaNumeric } from "../../../functions/SortFunctions";
import ProductFilters from "./ProductFilters";
import QuoteButton from "./QuoteButton";

export default function HiQInteractiveCatalogue(){

    const { setDisable , handlePageChange } = useContext(BrandCountryContext);

    const { loading , setLoading } = useContext(LoggedInContext);

    const [catalogueItems,setCatalogueItems] = useState([]);
    const [productGroups,setProductGroups] = useState([]);
    const [productFilters,setProductFilters] = useState([]);

    const [filteredProductGroups,setFilteredProductGroups] = useState([]);

    const navigate = useNavigate();

    useEffect(() => {
        handlePageChange(window.location.pathname);
    },[]);

    useEffect(() => {
        if(productGroups.length > 0 && productFilters.length > 0){
            setFilteredProductGroups(filterProducts(productGroups,productFilters));
        }
    },[productFilters,productGroups]);

    const filterProducts = (productArray,filters) => {
        let newArray = productArray;
        if(filters.some((filter) => filter.filterOn)){
            newArray = productArray.filter((product) => filters.some((filter) => filter.category === product.category && filter.filterOn));
        }
        return newArray;
    }  

    useEffect(() => {
        getCatalogueItems();
    },[]);

    const createProductListings = (array) => {
        console.log(array);
        const uniqueProductGroups = [...new Set(array.map((product) => product.productGroupCode ))].map((productGroupCode) => {
            const filterEntries = array.filter((product) => product.productGroupCode === productGroupCode);
            const imgArray = filterEntries.filter((product) => product.imgUrl !== null && product.imgUrl !== '').map((product) => product.imgUrl).join(',').split(',').map((url) => url.replace('/s/','/shared/static/'));
            const hashArray = filterEntries.filter((product) => product.hashString !== null && product.hashString !== '').map((product) => product.hashString).join('::').split('::');
            // console.log(filterEntries.filter((product) => product.imgUrl !== null && product.imgUrl !== ''));
            console.log(hashArray);
            return {
                productGroupCode,
                productGroupName: filterEntries[0].productGroupName,
                category: filterEntries[0].category,
                lowestCost: Math.min(...filterEntries.map((product) => Number(product.stratelaSalesCost))),
                imgArray: imgArray,
                hashArray: hashArray,
                noVariations: filterEntries.length,
                description: filterEntries[0].description,
                sortedProductVariations: filterEntries.sort(sortAlphaNumeric('code','asc','alpha'))
            }
        });
        setProductGroups(uniqueProductGroups.sort(sortAlphaNumeric('productGroupName','asc','alpha')).sort(sortAlphaNumeric('category','asc','alpha')));
    }

    const getCatalogueItems = async () => {
        setLoading(true);
        const headers = new Headers();
        headers.append('Content-Type','application/x-www-form-urlencoded');
        fetch(`${process.env.REACT_APP_STATUS === 'PRODUCTION'? process.env.REACT_APP_PRODUCTION_BACKEND : process.env.REACT_APP_BACKEND}/catalogue/8`,{
            method: 'GET',
            headers: headers,
            credentials: 'include',
        })
        .then((res) => res.text())
        .then((data) => {
            const recObj = JSON.parse(data);
            setCatalogueItems(recObj.catalogueItems);
            createProductListings(recObj.catalogueItems);
            setLoading(false);
        })
        .catch((err) => console.log(err));
    }

    return(
        <div className={generalStyles.container} >
            <div className={styles.topControls}>
                <ProductFilters array={productGroups} productFilters={productFilters} setProductFilters={setProductFilters}/>
            </div>
            <div className={styles.productCardContainer}>
                {filteredProductGroups.length > 0? filteredProductGroups.sort((objA,objB) => objB.imgArray.length - objA.imgArray.length).sort((objA,objB) => objB.imgArray[0].length - objA.imgArray[0].length).map((group) => <div><ProductCard productGroupObj={group}/></div>) : <div className={styles.noProducts} style={{gridColumn: '1/5'}}>No Products</div>}
            </div>
        </div>
    )
}